import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import React, { Fragment, useState } from 'react'
import { obtenerSolicitudesCompraFinanzas, obtenerSolicitudesCompraHologramas, obtenerCompraDetalle } from '../../../redux/DuckPanelHologramas/ModuloComprasDuck'
import { v4 as uuidv4 } from 'uuid';

const PanelComprasComponent = (props) => {

    const solicitudes = useSelector(store => store.ModuloCompras.data)
    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)
    React.useEffect(async () => {
        if(dataUser?.[0]?.idtipousuario == 10) await dispatch(obtenerSolicitudesCompraFinanzas())
        if(dataUser?.[0]?.idtipousuario == 9) await dispatch(obtenerSolicitudesCompraHologramas())
    }, [dataUser])

    const columns = [
        { field: 'numFolio', headerName: 'Núm. de folio', headerAlign: 'center', width: 150 },
        { field: 'numAsociado', headerName: 'Núm. de asociado', headerAlign: 'center', width: 170 },
        { field: 'fecha', headerName: 'Fecha', headerAlign: 'center', width: 150 },
        { field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 500 },
        { field: 'producto', headerName: 'Producto', headerAlign: 'center', width: 208 },
        {
            field: 'accion', headerName: 'Acción', headerAlign: 'center', width: 100,
            renderCell: (params) =>
            (
                <button className={`btn btn-outline-success`} onClick={() => detalleCompra(params)}>Revisar</button>
            )
        },
    ];

    const detalleCompra = async (params) => {
        await dispatch(obtenerCompraDetalle(params.row.idfc40_solicitudadquisicionholo))
        props.history.push('/DetalleDeCompraComponent')
    }

    const rows = [];
    solicitudes?.map(anexo => {

        let combinacionProducto = ''
        if (anexo.hologramasmezcal && anexo.hologramasbebidasmezcal) combinacionProducto = 'Mezcal y Bebidas con mezcal'
        else if (anexo.hologramasmezcal) combinacionProducto = 'Mezcal'
        else if (anexo.hologramasbebidasmezcal) combinacionProducto = 'Bebidas con mezcal'
        rows.push({
            id: uuidv4(), numFolio: anexo.folio, numAsociado: anexo.numerocliente, fecha: anexo.fechasolicitud.substring(0, 10),
            razonSocial: anexo.nombrerazonsocial, producto: combinacionProducto, idfc40_solicitudadquisicionholo: anexo.idfc40_solicitudadquisicionholo
        })
    })

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <GridToolbarQuickFilter style={{ backgroundColor: '#F8F9F9', width: '100%' }} placeholder='Búsqueda...' />
            </Box>
        );
    }

    return (
        <div className="container">
            <Box sx={{ height: 530, width: '100%', mt: 7 }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableColumnMenu={true}
                    components={{ Toolbar: QuickSearchToolbar }}
                    initialState={{ sorting: { sortModel: [{ field: 'fecha', sort: 'desc' }], }, }}
                    pageSize={10}
                    sx={{
                        boxShadow: 0,
                        color: 'black',
                        border: 0,
                        backgroundColor: 'white',
                        '& .MuiDataGrid-cell': {
                            display: 'block',
                            position: 'relative',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#4399A4',
                            color: 'white',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                            height: '20px'
                        }
                    }}
                />
            </Box>
        </div>
    );

};

export default PanelComprasComponent

